export default __webpack_public_path__ + "static/media/pdf.3dfcb5cd.png";